import React, {useState} from 'react';
import type {UserForm} from '@deezer/next/features/Account/type';
import {FormControl, FormLabel, Input} from '@tempo/core';
import {useTranslation} from 'next-i18next';

type UserEmailFormProps = {
	data: string;
	isDisabled?: boolean;
	isRequired?: boolean;
	onChange?: (value: Partial<UserForm>, isValid?: boolean) => void;
};

const UserEmailForm = ({
	data,
	isDisabled,
	onChange,
	isRequired,
}: UserEmailFormProps) => {
	const {t} = useTranslation('d4c');
	const [email, setEmail] = useState(data);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setEmail(value);
		if (onChange) {
			onChange({email: value});
		}
	};

	return (
		<FormControl isRequired={isRequired}>
			<FormLabel>{t('usermanager_text_email_d4c-web')}</FormLabel>
			<Input
				data-testid={'user-manager-form-email'}
				placeholder={t('usermanager_text_emailexample_d4c-web')}
				type="email"
				value={email}
				disabled={isDisabled}
				onChange={handleChange}
			/>
		</FormControl>
	);
};

export default UserEmailForm;
